import { Subject } from 'rxjs'

const licenseExpiredEventBus = new Subject<any>()

export default licenseExpiredEventBus
